import SkapaTooltip, { type TooltipProps } from "@ingka/tooltip";

export const Tooltip = (props: TooltipProps) => {
  return <SkapaTooltip prefix="saleslead__" {...props} />;
};
